// extracted by mini-css-extract-plugin
export default {"memberTeam":"styles_memberTeam__lck8a","memberName":"styles_memberName__HvBI-"};